import { Box, Typography, TextField, InputAdornment } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import { CONSTRAINTS } from "modules/optimization-settings/selectors/constraints"
import OPTooltip from "components/material/tooltip"
import { useFormContext } from "connected-components/optimize-experiments/form-context"

import "./style.scss"

export default function Rules() {
  const form = useFormContext()
  const maxTurnover = CONSTRAINTS.maxTurnover()
  const tooltip = maxTurnover.tooltip

  return (
    <Box className="components_rules">
      <Typography color="inherit" noWrap className="rules-label">
        Rules
      </Typography>
      <Box className="rules-constraint">
        <Typography color="inherit" noWrap>
          Max turnover:
        </Typography>
        <form.Field
          name="rules.maxTurnover"
          validators={{
            onChange: ({ value }: { value: number | string }) => {
              const error = maxTurnover.validation(value)
              if (error) return error
              return undefined
            },
          }}
        >
          {(field) => (
            <TextField
              id="constraint-max-turnover"
              variant="standard"
              type="number"
              value={field.state.value}
              onChange={(event) => field.handleChange(event.target.value)}
              onBlur={field.handleBlur}
              error={field.state.meta.errors.length > 0}
              helperText={field.state.meta.errors[0]}
              slotProps={{
                input: {
                  startAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="start">%</InputAdornment>,
                  endAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="end"><OPTooltip title={tooltip}><InfoOutlined /></OPTooltip></InputAdornment>,
                },
                htmlInput: {
                  min: maxTurnover.min,
                },
              }}
            />
          )}
        </form.Field>
      </Box>
    </Box>
  )
}
